// extracted by mini-css-extract-plugin
export const sectionSpacing = "separator-module--section-spacing--3FbS2";
export const rowSpacing = "separator-module--row-spacing--1atyk";
export const rowSpacingSml = "separator-module--row-spacing-sml--gKjTz";
export const separator = "separator-module--separator--p_9NC";